import { render, staticRenderFns } from "./basic-layout.vue?vue&type=template&id=705d39b9&scoped=true&"
import script from "./basic-layout.vue?vue&type=script&lang=js&"
export * from "./basic-layout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.10.0_enyi6aqizbgycdmugvkasw26ru/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "705d39b9",
  null
  
)

export default component.exports